import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import PresentationProfessional from "@/components/PresentationProfessional";

const BACKEND_URL = "";
const API = `${BACKEND_URL}/api`;

export default function PresentationView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [preventivo, setPreventivo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPreventivo = async () => {
      try {
        const response = await axios.get(`${API}/preventivi/${id}`);
        setPreventivo(response.data);
      } catch (err) {
        setError("Preventivo non trovato");
      } finally {
        setLoading(false);
      }
    };

    fetchPreventivo();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white/60">Caricamento presentazione...</p>
        </div>
      </div>
    );
  }

  if (error || !preventivo) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <p className="text-white/60 mb-4">{error || "Preventivo non trovato"}</p>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 bg-white/10 text-white rounded-lg hover:bg-white/20"
          >
            Torna al configuratore
          </button>
        </div>
      </div>
    );
  }

  return (
    <PresentationProfessional
      preventivo={preventivo}
      onClose={() => navigate("/")}
    />
  );
}
